import Tracking from './tracking.js';

const tracking = new Tracking();

/**
 * Google Analytics logger for WatchingYou module
 * @class WatchingYouGA
 */
export default class WatchingYouGA {

	/**
	 * Method called by WatchingYou instance
	 * @param {string} level log,info,warn,error
	 * @param {Date} date Date instance
	 * @param {Array<*>} data error
	 * @public
	 * @memberof WatchingYouGA
	 */
	log(level, date, [error]) {
		if (level === 'error' && error) {
			tracking.jsError(error);
		}
	}

}
